import { shopifyService } from 'services';
import io from 'socket.io-client';
import * as account from './account';
import shortid from 'shortid';
import { shopify } from '../../config/secrets';

export const FETCH_ORDERS_BEGIN = 'ORDERS/FETCH_ORDERS_BEGIN';
export const FETCH_ORDERS_SUCCESS = 'ORDERS/FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_ERROR = 'ORDERS/FETCH_ORDERS_ERROR';

export const EXPORT_ORDERS_BEGIN = 'ORDERS/EXPORT_ORDERS_BEGIN';
export const EXPORT_ORDERS_SUCCESS = 'ORDERS/EXPORT_ORDERS_SUCCESS';
export const EXPORT_ORDERS_STATUS = 'ORDERS/EXPORT_ORDERS_STATUS';
export const EXPORT_ORDERS_ERROR = 'ORDERS/EXPORT_ORDERS_ERROR';

export const UPDATE_INVOICE_BEGIN = 'INVOICE/UPDATE_INVOICE_BEGIN';
export const UPDATE_INVOICE_SUCCESS = 'INVOICE/UPDATE_INVOICE_SUCCESS';
export const UPDATE_INVOICE_ERROR = 'INVOICE/UPDATE_INVOICE_ERROR';

export const CREATE_INVOICE_BEGIN = 'CREATE_INVOICE_BEGIN';
export const CREATE_INVOICE_ERROR = 'CREATE_INVOICE_ERROR';
export const CREATE_INVOICE_END = 'CREATE_INVOICE_END';
export const STORNO_INVOICE_BEGIN = 'STORNO_INVOICE_BEGIN';
export const STORNO_INVOICE_END = 'STORNO_INVOICE_END';

export const FULFILL_ORDER_BEGIN = 'FULFILL_ORDER_BEGIN';
export const FULFILL_ORDER_END = 'FULFILL_ORDER_END';

export const CANCEL_ALL_FULFILLMENTS_BEGIN = 'CANCEL_ALL_FULFILLMENTS_BEGIN';
export const CANCEL_ALL_FULFILLMENTS_END = 'CANCEL_ALL_FULFILLMENTS_END';

export const UPDATE_ORDER_BEGIN = 'UPDATE_ORDER_BEGIN';
export const UPDATE_ORDER_END = 'UPDATE_ORDER_END';

export const SELECT_ORDER = 'SELECT_ORDER';
export const MARK_AS_PROCESSING = 'MARK_AS_PROCESSING';

export const MARK_AS_PAID_RESULT= 'MARK_AS_PAID_RESULT';
export const MARK_AS_PAID_BEGIN= 'MARK_AS_PAID_BEGIN';
export const MARK_AS_PAID_END= 'MARK_AS_PAID_END';

export const CLEAR_MARK_AS_PAID_RESULTS = 'CLEAR_MARK_AS_PAID_RESULTS';

export function selectOrder(order, has_credit_note, isUpdate, editStorno){
    return {
        type: SELECT_ORDER,
        order: order,
        has_credit_note: has_credit_note,
        isUpdate: isUpdate,
        editStorno: editStorno
    }
}
export function fetchOrdersBegin(filter) {
    return {
        type: FETCH_ORDERS_BEGIN,
        silent: filter.silent,
        filter: filter
    }
}

export function exportOrdersBegin() {
    return {
        type: EXPORT_ORDERS_BEGIN
    }
}

export function markAsProcessing(id, shop_name, status){
    return {type: MARK_AS_PROCESSING, id: id, shop_name: shop_name, status: status};
}

export function exportOrdersSuccess(data) {
    return { type: EXPORT_ORDERS_SUCCESS, data: data };
}

export function exportOrdersError(error) {
    return { type: EXPORT_ORDERS_ERROR, error: error };
}

export function fetchOrdersSuccess(data) {
  /*  data.orders = data.orders.filter((i)=>{
        return (i.email && i.email.length > 0)
    })*/

    return { type: FETCH_ORDERS_SUCCESS, data: data };
}

export function fetchOrdersError(error) {
    return { type: FETCH_ORDERS_ERROR, error: error };
}

export function fetchOrders(filter) {

    return (dispatch) => {
        dispatch(fetchOrdersBegin(filter));
        shopifyService().getOrders(filter).then((res) => {
            return dispatch(fetchOrdersSuccess(res.data));
        }).catch((error) => {
            return dispatch(fetchOrdersError('Failed to load oders. Please try again later.'));
        });
    }
}

export function createInvoicesBegin() {
    return {
        type: CREATE_INVOICE_BEGIN
    }
}

export function createInvoicesError(error) {
    return {
        type: CREATE_INVOICE_ERROR,
        error
    }
}

export function createInvoicesEnd() {
    return {
        type: CREATE_INVOICE_END
    }
}

export function updateInvoiceBegin(){
    return {
        type: UPDATE_INVOICE_BEGIN
    }
}

export function updateInvoiceSuccess(){
    return {
        type: UPDATE_INVOICE_SUCCESS
    }
}

export function updateInvoiceError(){
    return {
        type: UPDATE_INVOICE_ERROR
    }
}

export function updateInvoice(invoice, filter){
    return (dispatch) => {
        dispatch(fetchOrdersBegin(filter));
        dispatch(updateInvoiceBegin());
        shopifyService().updateInvoice(invoice).then(()=>{
            dispatch(updateInvoiceSuccess());
            dispatch(fetchOrders(filter));
        }).catch(()=>{
            dispatch(updateInvoiceError());
        })
    }
}

export function createInvoices(selected, oldfilter, date) {
    date = new Date(date).getTime();

    return (dispatch) => {
        dispatch(fetchOrdersBegin(oldfilter));
        dispatch(createInvoicesBegin());
        let filter = {
            ids: [],
            date
        }

        for (var id in selected) {
            if (selected[id] === true)
                filter.ids.push(id);
        }
        filter.ids = filter.ids.join(',');

        shopifyService().createInvoices(filter).then((res) => {
            dispatch(fetchOrders(oldfilter));
            dispatch(createInvoicesEnd());
            dispatch(account.fetchAccount());
        }).catch((error) => {
            dispatch(createInvoicesError(error.response.data));
        });
    }
}

export function setCustomerInvoiceExclusion(customerId, excluded) {
    return (dispatch) => {
        return shopifyService().setCustomerInvoiceExclusion(customerId, excluded).then(() => {
            return dispatch(account.fetchAccount()).then(() => {
                return { customerId, excluded };
            });
        });
    }
}

export function fulfillOrderBegin() {
    return {
        type: FULFILL_ORDER_BEGIN
    }
}
export function fulfillOrderEnd() {
    return {
        type: FULFILL_ORDER_END
    }
}

export function updateOrderBegin() {
    return {
        type: UPDATE_ORDER_BEGIN
    }
}
export function updateOrderEnd() {
    return {
        type: UPDATE_ORDER_END
    }
}

export function updateOrder(order, filter) {
    return (dispatch) => {
        dispatch(fetchOrdersBegin(filter));
        dispatch(updateOrderBegin());
        
        order.date_created = new Date(order.date_created).getTime();
        order.date_storno = new Date(order.date_storno).getTime();

        shopifyService().updateOrder(order).then(() => {
            dispatch(fetchOrders(filter));
            dispatch(updateOrderEnd());
        }).catch(() => {
            dispatch(updateOrderEnd());
        });
    }
}


export function fulfillOrder(order, filter) {
    return (dispatch) => {
        dispatch(fulfillOrderBegin());
        shopifyService().fulfillOrder(order).then(() => {
            dispatch(fetchOrders(filter));
            dispatch(fulfillOrderEnd());
        }).catch(() => {
            dispatch(fulfillOrderEnd());
        });
    }
}

export function cancelAllFullfillmentsBegin() {
    return {
        type: CANCEL_ALL_FULFILLMENTS_BEGIN
    }
}

export function cancelAllFullfillmentsEnd() {
    return {
        type: CANCEL_ALL_FULFILLMENTS_END
    }
}

export function cancelAllFulfillments(order, filter) {
    return (dispatch) => {
        dispatch(cancelAllFullfillmentsBegin());
        shopifyService().cancelAllFullfillments(order).then(() => {
            dispatch(fetchOrders(filter));
            dispatch(cancelAllFullfillmentsEnd());
        }).catch(() => {
            dispatch(cancelAllFullfillmentsEnd());
        });
    }
}

export function stornoInvoicesBegin() {
    return {
        type: STORNO_INVOICE_BEGIN
    }
}
export function stornoInvoicesEnd(error) {
    return {
        type: STORNO_INVOICE_END,
        error
    }
}
export function stornoInvoices(selected, oldfilter, date, order) {
    date =  new Date(date).getTime();
    return (dispatch) => {
        dispatch(fetchOrdersBegin(oldfilter));
        dispatch(stornoInvoicesBegin());
        let filter = {
            ids: [],
            date,
            order
        }

        for (var id in selected) {
            if (selected[id] === true)
                filter.ids.push(id);
        }
        filter.ids = filter.ids.join(',');
        shopifyService().stornoInvoices(filter).then((res) => {
            dispatch(fetchOrders(oldfilter));
            dispatch(account.fetchAccount());
            dispatch(stornoInvoicesEnd());
        }).catch((error) => {
            dispatch(stornoInvoicesEnd(error));
        });
    }
}

export function markOrdersAsPaid(orders){
    return (dispatch)=>{
        dispatch(clearMarkAsPaidResults());
        dispatch(markAsPaidBegin());
        shopifyService().markOrdersAsPaid({orders, sessionId});
    }
    
}


export function exportOrdersStatus(status) {
    return {
        type: EXPORT_ORDERS_STATUS,
        status
    }
}

export function changeExportOrdersStatus(msg) {
    return (dispatch) => {
        dispatch(exportOrdersStatus(msg.status));
    }
}

export function markAsPaidResult(message){
    return {
        type: MARK_AS_PAID_RESULT,
        message
    }
}

export function markAsPaidBegin(){
    return {
        type: MARK_AS_PAID_BEGIN
    }
}

export function markAsPaidEnd(){
    return {
        type: MARK_AS_PAID_END
    }
}

export function clearMarkAsPaidResults(){
    return {
        type: CLEAR_MARK_AS_PAID_RESULTS
    }
}
export function markAsPaidResultReceived(msg){
    return (dispatch) =>{
        dispatch(markAsPaidResult(msg));
    }
}

export function exportOrdersFileDataReceived(msg) {
    return (dispatch) => {

        var arrBuffer = msg.data;
        var newBlob;
        var format = msg.format;
        var fileName = msg.fileName;

        if (format === 'pdf') {
            newBlob = new Blob([arrBuffer], { type: "application/pdf" });
        }
        if (format === 'zip') {
            newBlob = new Blob([arrBuffer], { type: "octet/stream" });
        }

        if (format === 'xlsx') {
            newBlob = new Blob([arrBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        }

        if (format === 'xml') {
            newBlob = new Blob([arrBuffer], { type: "application/xml" });
        }

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob, `${fileName}.${format}`);
            dispatch(exportOrdersSuccess());
            dispatch(changeExportOrdersStatus({ status: 0 }));
            return;
        }

        // For other browsers: 
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        var link = document.createElement('a');
        link.href = data;
        link.download = `${fileName}.${format}`;
        link.setAttribute('download', `${fileName}.${format}`);
        document && document.body.appendChild(link);
        link.click();
        setTimeout(function () {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
        }, 100);

        dispatch(exportOrdersSuccess());
        dispatch(changeExportOrdersStatus({ status: 0 }));
    }
}

let sessionId = shortid.generate();
let socket = null;
if (typeof location !== "undefined") {

    socket = io({
        'reconnection': true,
        'reconnectionDelay': 1000,
        'reconnectionDelayMax': 5000,
        'reconnectionAttempts': 15,
        'transports': ['websocket', 'polling']
    });

}
let msg = null;
let gotUpdate = false;

export function initSocket() {
    return (dispatch, getState) => {

        setInterval(()=>{
            let state = getState().orders;
            if (gotUpdate){
                dispatch(fetchOrders({...state.filter,
                    limit: state.limit,
                    silent:true
                    }));
                dispatch(account.fetchAccount());
                gotUpdate = false;
            }

        }, 15000);

        socket.on('process_order', function(m){

            dispatch(markAsProcessing(m.order_id, m.shop_name, m.status));
            if (!m.status){
                gotUpdate = true;
            }
        })
        socket.on('download_status_' + sessionId, function (m) {
            setTimeout(function () {
                msg = m;
            }, 100);
        }.bind(this));

        socket.on('download_error_' + sessionId, function (m){
            dispatch(exportOrdersError(m.err));
        }.bind(this));

        socket.on('file_data_' + sessionId, function (m) {
            dispatch(exportOrdersFileDataReceived({
                ...m,
                socket
            }));
            setTimeout(function () {
                msg = null;
            }, 5000);

        }.bind(this));

        setInterval(() => {
            if (msg !== null)
                dispatch(changeExportOrdersStatus(msg));
        }, 1000);

        socket.on('mark_paid_' + sessionId, function(m){ 
            if (m.name === "done"){
                dispatch(markAsPaidEnd());
            }else{
                let state = getState().orders;
                dispatch(markAsPaidResultReceived(m))
                dispatch(fetchOrders({...state.filter,
                    limit: state.limit,
                    silent:true
                }));
            }
        })
    }
}

export function deliverInvoice(orderId, isStorno, filter) {
    return (dispatch) => {
        shopifyService().deliverInvoice({ orderId, isStorno }).then(() => {
            dispatch(fetchOrders(filter));
        }).catch(() => {});
    }
}

export function exportOrders(selected, settings) {
    return (dispatch) => {

        dispatch(exportOrdersBegin());

        let filter = {
            ids: [],
            settings,
            sessionId
        }

        for (var id in selected) {
            if (selected[id] === true)
                filter.ids.push(id);
        }
        filter.ids = filter.ids.join(',');

        if (!filter.ids && settings.what === 'orders')
            return dispatch(exportOrdersSuccess());

        shopifyService().exportOrders(filter).then((res) => {

        }).catch((error) => {
            dispatch(exportOrdersError(error.response.data));
        });
    }
}


const reducer = (state = {
    fetching: true,
    exporting: false,
    invoicing: false,
    stornoing: false,
    fulfilling: false,
    needUpgrade: false,
    hasError: false,
    list: [],
    markAsPaidResults: [],
    markAsPaidResultsProcessing: false,
    totalCount: 0,
    status: 0,
    sessionId: null,
    updatingOrder: false,
    selectedOrder: {}
}, action = {}) => {

    switch (action.type) {

        case CLEAR_MARK_AS_PAID_RESULTS:
            return {
                ...state,
                markAsPaidResults: [],
                markAsPaidResultsProcessing: false
            }
        case MARK_AS_PAID_BEGIN: 
            return {
                ...state,
                markAsPaidResultsProcessing: true
            }
        case MARK_AS_PAID_END: 
            return {
                ...state,
                markAsPaidResultsProcessing: false
            }        
        case MARK_AS_PAID_RESULT:
            return {
                ...state,
                markAsPaidResultsProcessing: true,
                markAsPaidResults: [...state.markAsPaidResults, action.message]
            }
        case MARK_AS_PROCESSING:
            return {
                ...state,
                list: state.list.map((o)=>{
                    let processing =  o.id === action.id  && o.shop_name === action.shop_name ? action.status : o.processing;
                    return {
                        ...o,
                        processing: processing,
                    }
                })
            }

        case FETCH_ORDERS_BEGIN:
            return {
                ...state,
                filter: action.filter,
                fetching: true,
                isSaving: false
            };
        case FETCH_ORDERS_SUCCESS:
            
            let findWithId = id => state.list.find(o=>o.id === id);
            return {
                ...state,
                fetching: false,
                list: [...action.data.orders].map((o)=>{
                    let existing = findWithId(o.id) || {};
                    return {
                        ...o,
                        processing: existing.processing
                    }
                }),
                next: action.data.next,
                previous: action.data.previous,
                totalCount: action.data.totalCount
            };
        case FETCH_ORDERS_ERROR:
            return {
                ...state,
                fetching: false,
                isSaving: false,
                list: [],
                totalCount: 0
            };

        case EXPORT_ORDERS_BEGIN:
            return {
                ...state,
                exporting: true,
                hasError: false,
            };

        case EXPORT_ORDERS_STATUS: {
            return {
                ...state,
                status: action.status
            }
        }

        case CREATE_INVOICE_BEGIN:
            return {
                ...state,
                invoicing: true,
                hasError: false
            };
        case CREATE_INVOICE_END:
            return {
                ...state,
                invoicing: false,
                needUpgrade: action.error && action.error.response.status === 400,
                hasError: false
            };
        case CREATE_INVOICE_ERROR:
        return {
            ...state,
            invoicing: false,
            error: action.error,
            hasError: true
        }
        case STORNO_INVOICE_BEGIN:
            return {
                ...state,
                stornoing: true
            };
        case STORNO_INVOICE_END:
            return {
                ...state,
                stornoing: false,
                needUpgrade: action.error && action.error.response.status === 400
            };

        case FULFILL_ORDER_BEGIN:
            return {
                ...state,
                fulfilling: true
            };
        case FULFILL_ORDER_END:
            return {
                ...state,
                fulfilling: false
            };
        case UPDATE_ORDER_BEGIN:
            return {
                ...state,
                updateOrder: true
            };
        case UPDATE_ORDER_END:
            return {
                ...state,
                updateOrder: false
            };
        case EXPORT_ORDERS_SUCCESS:

            return {
                ...state,
                exporting: false,
                hasError: false,
                status: 0
            };
        case EXPORT_ORDERS_ERROR:
            return {
                ...state,
                exporting: false,
                hasError: true,
                error: action.error,
                needUpgrade: action.error &&  action.error.response ? action.error.response.status === 400 : false
            };
        case SELECT_ORDER:
            return {
                ...state,
                selectedOrder: {...action.order,
                    isUpdate: action.isUpdate,
                    editStorno: action.editStorno,
                    has_credit_note: action.has_credit_note,
                    customer: {
                        ...action.order.customer
                    },
                    shipping_lines: [
                        ...action.order.shipping_lines
                    ],
                    line_items: [
                        ...action.order.line_items
                    ]
                }
            }
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// app/modules/orders.js